import React from 'react'
import { Link } from 'react-router-dom'
import Icons from '../myIcon/Icons'

export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-8">
              <div className="row">
                <div className="col-6 col-lg-5 col-sm-4">
                  <div className="footer-links">
                    <div className="link-title">Solutions</div>
                    <ul>
                      <li><Link to={"/physical-records-management-services"}>Physical Records</Link></li>
                      <li><Link to={"/document-digitization"}>Scanning & Digitization Services</Link></li>
                      <li><Link to={"/ai-document-data-extraction"}>AI-driven Extraction</Link></li>
                      <li><Link to={"/data-privacy-governance-compliance-platform"}>Data Governance & Compliance</Link></li>
                    </ul>
                  </div>
                </div>

                <div className="col-6 col-lg-3 col-sm-4">
                  <div className="footer-links">
                    <div className="link-title">Insights</div>
                    <ul>
                      <li><Link to={"/blog"}>Blogs</Link></li>
                      {/* <li><Link to={"/press-release"}>Press Releases</Link></li>
                      <li><Link to={"/case-study"}>Case Studies</Link></li> */}
                      <li><Link to={"/contact"}>Contact Us</Link></li>
                    </ul>
                  </div>
                </div>

                <div className="col-12 col-lg-4 col-sm-4">
                  <div className="footer-links footer-links-mobile">
                    <div>
                      <div className="link-title">Company </div>
                    <ul>
                      <li><Link to={"/about-us"}>About</Link></li>
                      <li><Link to={"/team"}>Team</Link></li>
                      <li><Link to={"/location"}>Locations</Link></li>
                      <li><Link to={"/sustainability"}>Sustainability</Link></li>
                    </ul>
                    </div>

                    <div>
                      <div className="link-title mt-5">Social Media</div>
                    <ul className="footer-social">
                      <li><a href="https://www.facebook.com/doxandbox" target="_blank" aria-label="Facebook"><Icons name="facebook" /></a></li>
                      <li><a href="https://x.com/doxandbox" target="_blank"><Icons name="twitter" /></a></li>
                      <li><a href="https://in.linkedin.com/company/doxandbox/" target="_blank"><Icons name="linkedin" /></a></li>
                      <li><a href="https://www.instagram.com/doxandboxindia" target="_blank"><Icons name="instagram" /></a></li>
                    </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4">
              <div className="footer-app">
                <div className="footer-app-track">
                  <img src="/assets/images/footer-certificate-1.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-2.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-3.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-4.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-5.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-6.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-7.webp" alt="Certificate" />
                  {/* duplicate for marque */}
                  <img src="/assets/images/footer-certificate-1.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-2.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-3.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-4.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-5.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-6.webp" alt="Certificate" />
                  <img src="/assets/images/footer-certificate-7.webp" alt="Certificate" />
                </div>
              </div>

              <div className="footer-rating">
                <img src="/assets/images/footer-rating.webp" alt="Ratings" />
              </div>

              <div className="footer-contact">
                <a href="tel:+91-9580 374 374"><img src="/assets/images/footer-phone.webp" alt="Phone" /> +91-9580 374 374</a>
                <a href="mailto:info@doxandbox.com"><img src="/assets/images/footer-mail.webp" alt="Mail" />
                  info@doxandbox.com</a>
              </div>
            </div>

          </div>

          <div className="row">
            <div className="col-lg-12">
              <img src="/logo-white.webp" alt="Footer Logo" className="footer-logo" />
              <div className="footer-copyright">
                <p>© 2026 Dox and Box. All Rights Reserved.</p>
                <ul className="footer-privacy">
                  <li><Link to={"/terms-condition"}>Privacy Policy</Link></li>
                  <li><Link to={"/terms-condition"}>Terms & Conditions</Link></li>
                  <li><a target='_blank' href={"/sitemap.xml"}>Sitemap</a></li>
                </ul>
                <p>Designed by <a href='https://www.88gravity.com/' target='_blank'>88gravity</a></p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
